<template>
  <el-dialog
    :close-on-click-modal="false"
    :title="(type === 'add' ? '新增' : '修改') + '维保明细'"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
    :append-to-body="true"
    width="800px"
  >
    <section v-loading="getDetailLoading">
      <qx-custom-form @sub="sub" :noSubBtn="true" ref="customForm" :formData="formData">
        <!-- 车牌号码 -->
        <section slot="car" slot-scope="prop">
          <ChooseCar
            :otherSearchData="{
            orgId
          }"
            :isRadio="true"
            v-model="prop.form.car"
          />
        </section>
        <!-- 车牌号码 end -->
        <!-- 订单 -->
        <section slot="order" slot-scope="prop">
          <ChooseOrder
            slot="order"
            :isRadio="true"
            v-model="prop.form.order"
            @change="handleOrderChange"
            :otherSearchData="{
            orgId
          }"
          />
        </section>
        <!-- 订单 end -->
        <!-- 司机姓名 -->
        <section slot="driver" slot-scope="prop">
          <ChooseDriver :isRadio="true" v-model="prop.form.driver" />
        </section>
        <!-- 司机姓名 end -->
        <!-- 维保信息 -->
        <section class="posire" slot="maintenance" slot-scope="prop">
          <ChooseMaintenance
            :isRadio="true"
            v-model="prop.form.maintenance"
            @change="handleMaintenanceChange"
          />
          <span class="clearBtn blur cur posiab" @click="clearMaintenance">清空</span>
        </section>
        <!-- 维保信息 end -->
        <!-- 配件信息 -->
        <section slot="maintenanceDetail" slot-scope="prop">
          <el-table class="tableBox" :data="prop.form.maintenanceDetail" tooltip-effect="dark">
            <!-- 常规列表项 -->
            <el-table-column
              v-for="(item, index, key) in pairsTableTitle"
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :min-width="item.minW"
              :width="item.w"
            />
          </el-table>
        </section>
        <!-- 配件信息 end -->
      </qx-custom-form>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button
        type="primary"
        @click="customFormPost"
        :loading="subLoading || getDetailLoading"
      >确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  maintenancePairInfoList,
} from 'api/cost';
import ChooseCar from 'components/choose/car';
import ChooseOrder from 'components/choose/order';
import ChooseDriver from 'components/choose/driver';
import ChooseMaintenance from 'components/choose/maintenance';
export default {
  components: {
    ChooseCar,
    ChooseOrder,
    ChooseDriver,
    ChooseMaintenance,
  },
  props: {
    orgId: {
      default: '',
    },
  },
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      pairsTableTitle: [
        {
          label: '类型',
          prop: 'partsName',
        },
        {
          label: '数量(个)',
          prop: 'partsNumber',
        },
        {
          label: '总金额',
          prop: 'totalPartsPriceStr',
        },
        {
          label: '备注',
          prop: 'partsRemark',
        },
      ],
      formData: {
        form: [
          {
            label: '车牌号码',
            value: 'car',
            default: {},
            slot: true,
          },
          {
            label: '申请金额',
            value: 'payAmt',
            type: 'input',
            placeholder: '请输入申请金额',
          },
          {
            label: '司机姓名',
            value: 'driver',
            default: {},
            slot: true,
          },
          // {
          //   label: '司机手机',
          //   value: 'mobilePhone',
          //   type: 'input',
          //   disabled: true,
          // },
          {
            label: '订单号码',
            value: 'order',
            slot: true,
            default: {},
          },
          {
            label: '上传附件',
            value: 'file',
            type: 'img',
            accept: 'image/*',
            default: [],
          },
          {
            label: '受损图片',
            value: 'beforePicList',
            type: 'img',
            accept: 'image/*',
            default: [],
          },
          {
            label: '维保信息',
            value: 'maintenance',
            default: {},
            slot: true,
          },
          {
            label: '维修电话',
            value: 'repairmanTel',
            type: 'input',
            disabled: true,
            hide: true,
          },
          {
            label: '维修费用',
            value: 'payAmt',
            type: 'input',
            disabled: true,
            hide: true,
          },
          {
            label: '发票类型',
            value: 'isNeedBillName',
            type: 'input',
            disabled: true,
            hide: true,
          },
          {
            label: '维修内容',
            value: 'serviceContent',
            type: 'input',
            disabled: true,
            hide: true,
          },
          {
            label: '配件信息',
            value: 'maintenanceDetail',
            slot: true,
            hide: true,
          },
        ],
        rules: { // 表单验证规则
          car: [ // 车牌号码
            { required: true, message: '请选择车牌号码', trigger: 'blur' },
          ],
          payAmt: [ // 申请金额
            { required: true, message: '请输入申请金额', trigger: 'blur' },
          ],
          driver: [ // 司机姓名
            { required: true, message: '请选择司机姓名', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    clearMaintenance () {
      this.$refs.customForm.setVal('maintenance', {});
      this.handleMaintenanceChange();
    },

    // handleDriverChange () {
    //   const driver = this.$refs.customForm.getVal('driver');
    // },
    handleOrderChange (data) {
      this.$refs.customForm.setVal('plateNumber', data.plateNumber); // 车牌号
    },

    async handleMaintenanceChange () { // 维保信息选择
      const maintenance = this.$refs.customForm.getVal('maintenance');
      this.$refs.customForm.setVal('contractMobile', maintenance.contractMobile);
      this.$refs.customForm.setVal('checkAmount', maintenance.checkAmount);
      this.$refs.customForm.setVal('isNeedBillName', maintenance.isNeedBillName);
      this.$refs.customForm.setVal('serviceContent', maintenance.serviceContent);
      this.setFormAttrVal({
        form: this.formData,
        attr: 'hide',
        value: !maintenance.orderCode,
        names: ['contractMobile', 'checkAmount', 'isNeedBillName', 'serviceContent', 'maintenanceDetail'],
      });
      const pairsList = await maintenancePairInfoList({
        flowId: maintenance.flowId,
      });
      this.$refs.customForm.setVal('maintenanceDetail', pairsList.items);
    },

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.$nextTick(() => {
        this.$refs.customForm && this.$refs.customForm.reset();
        this.originData = item;
        if (item) { // 修改
          // console.log(item);
          this.type = 'edit';
          this.originData = item;
          // 订单信息
          item.order = {
            orderId: item.orderId,
          };
          // 车辆信息
          item.car = {
            plateNumber: item.plateNumber,
            vehicleCode: item.vehicleCode,
            licenceType: item.licenceType,
            vehicleOrgName: item.vehicleOrgName,
            orgId: item.orgId,
            orgName: item.orgName,
            vehicleOwnerShipName: item.vehicleOwnerShipName,
          };
          item.loginAcct = item.loginAcct || item.mobilePhone;
          // 司机姓名
          item.driver = {
            linkman: item.userName,
            userId: item.userId,
            loginAcct: item.mobilePhone,
          };
          console.log(item);
          this.$refs.customForm.setVal(item);
          this.handleMaintenanceChange();
        } else { // 新增
          this.type = 'add';
        }
      });
    },

    customFormPost () {
      this.$refs.customForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      // 订单信息
      form.orderId = String(form.order.orderId);
      delete form.order;
      // 车辆信息
      form.plateNumber = form.car.plateNumber;
      form.vehicleCode = form.car.vehicleCode;
      form.licenceType = form.car.licenceType;
      form.vehicleOrgName = form.car.vehicleOrgName;
      form.orgId = form.car.orgId;
      form.orgName = form.car.orgName;
      form.carNo = form.car.plateNumber;
      delete form.car;
      // 司机姓名
      form.userName = form.driver.linkman;
      // form.linkman = form.driver.linkman;
      form.userId = form.driver.userId;
      form.mobilePhone = form.driver.loginAcct;
      // form.loginAcct = form.driver.loginAcct;
      delete form.driver;
      form = {
        ...form.maintenance,
        ...form,
      };
      // 维保信息
      // form.repairmanTel = form.maintenance.repairmanTel;
      // form.transAmt = form.maintenance.repairmanTel;
      // form.isNeedBillName = form.maintenance.repairmanTel;
      // form.serviceContent = form.maintenance.repairmanTel;
      // form.flowId = form.maintenance.repairmanTel;
      // delete form.maintenance;
      // console.log(form);
      this.$emit('sub', {
        form,
        originData: this.originData,
      });
      this.dialogFormVisible = false;
    },
  },
};
</script>

<style scoped lang="scss">
.clearBtn {
  right: 10px;
  top: 0;
  left: 250px;
}
</style>
